<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$tc("m.BT_" + betType, 2) + " 4D"')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.type')" size="sm")
                  b-form-select(
                    ref="num_type"
                    v-model="num_type"
                    :options="['ALL','3D','4D']"
                    size="sm"
                    :disabled="loading"
                    @change="search"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.timer')" size="sm")
                  b-form-select(
                    ref="refresh"
                    v-model="refresh"
                    :options="refreshOptions"
                    size="sm"
                    :disabled="loading"
                    @change="refreshTimer"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh') + (refresh > 0 ? ' (' +  timer + ' ' + $t('ui.seconds') + ')' : '')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="search")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="betList" :fields="fields" :per-page="perPage" :filter="filter")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(bet_time)="row")
                    span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                    br
                    span #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    span #[b {{ $t("m.D_"  + row.item.bet_type) }}]
                    div {{ row.item.comp_name }} - {{ row.item.num_type }}
                    div {{ $moment(row.item.match_date).format("YYYY-MM-DD") }}
                  template(v-slot:cell(detail)="row")
                    .small.badge.badge-dark #[b {{ '\u200C' + row.item.number.toString() }}]
                    .small(v-if="parseFloat(row.item.big) > 0")
                      span {{ row.item.num_type == "4D" ? $t("m.D_BIG") : "AE" }}
                      span  x {{ row.item.big | currency }}
                    .small(v-if="parseFloat(row.item.small) > 0")
                      span {{ $t("m.D_SMALL") }}
                      span  x {{ row.item.small | currency }}
                    .small(v-if="parseFloat(row.item.sa) > 0")
                      span {{ row.item.num_type == "4D" ? "SA" : "A" }}
                      span  x {{ row.item.sa | currency }}
                    .small(v-if="parseFloat(row.item.sb) > 0")
                      span B
                      span  x {{ row.item.sb | currency }}
                    .small(v-if="parseFloat(row.item.sc) > 0")
                      span C
                      span  x {{ row.item.sc | currency }}
                    .small(v-if="parseFloat(row.item.sd) > 0")
                      span D
                      span  x {{ row.item.sd | currency }}
                    .small(v-if="parseFloat(row.item.se) > 0")
                      span E
                      span  x {{ row.item.se | currency }}
                    .small(v-if="parseFloat(row.item.aa) > 0")
                      span AA
                      span  x {{ row.item.aa | currency }}
                    .small(v-if="parseFloat(row.item.abc) > 0")
                      span ABC
                      span  x {{ row.item.abc | currency }}
                  template(v-slot:cell(bet_amount)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    betType: {
      type: String,
      default: "ALL"
    }
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      refreshOptions: [
        { value: 0, text: this.$t("ui.no_refresh") },
        { value: 15, text: 15 + ' ' + this.$t("ui.seconds") },
        { value: 30, text: 30 + ' ' + this.$t("ui.seconds") },
        { value: 45, text: 45 + ' ' + this.$t("ui.seconds") },
        { value: 60, text: 60 + ' ' + this.$t("ui.seconds") }
      ],
      num_type: '4D',
      member_id: this.$store.getters.getSelectedID == this.$store.getters.accountID ? "" : this.$store.getters.getSelectedID,
      filter: null,
      sortBy: "bet_time",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      countdown: null,
      timer: 60,
      refresh: 0
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_time",
          label: this.$t("ui.date_time"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_amount",
          label: this.$t("ui.amount"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.search()
    this.countdown = setInterval(() => {
      if(this.refresh > 0) {
        if(this.timer > 0) {
          this.timer -= 1
        } else {
          this.timer = this.refresh
          this.search()
        }
      }
    }, 1 * 1000)
  },
  beforeDestroy: function() {
    clearInterval(this.countdown)
  },
  methods: {
    refreshTimer() {
      this.timer = this.refresh
      this.search()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.search()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.search()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    search: function() {
      if (!this.$v.$invalid) {
        let num_type = this.num_type == 'ALL' ? "" : this.num_type
        let member_id = this.member_id
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getActiveBetlistLottery", { member_id, num_type, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.totalRows = 0
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.totalRows = response.data.length > 0 ? this.betList[0]["totalrows"] : 0
              } else {
                this.betList = []
                this.totalRows = 0
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.totalRows = 0
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
};
</script>